export default __webpack_public_path__ + "static/wr-wiktoria-rozuk-f1d55ef667ea3b26d3e5d0a101225d4e.jpg";